import React from "react";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";

interface Option {
  label: string;
  value: any;
}

interface DropdownProps {
  id?: string;
  name?: string;
  value?: any;
  options: Option[];
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  className?: string;
  error?: string;
  label?: string;
  filter?: boolean;
  showClear?: boolean;
  optionLabel?: string;
  optionValue?: string;
  onChange?: (e: { value: any }) => void;
  onBlur?: (e: React.FocusEvent<HTMLElement>) => void;
  loading?: boolean;
}

export function Select({
  id,
  name,
  value,
  options,
  placeholder = "Select an option",
  disabled = false,
  required = false,
  className,
  error,
  label,
  filter = false,
  showClear = false,
  optionLabel = "label",
  optionValue = "value",
  onChange,
  onBlur,
  loading,
}: DropdownProps) {
  const inputId = id || name;

  return (
    <div className="block">
      {label && (
        <label htmlFor={inputId} className="block mb-2">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <Dropdown
        id={inputId}
        name={name}
        value={value}
        options={options}
        placeholder={placeholder}
        disabled={disabled}
        filter={filter}
        showClear={showClear}
        optionLabel={optionLabel}
        optionValue={optionValue}
        className={classNames("w-full", { "p-invalid": error }, className)}
        onChange={onChange}
        onBlur={onBlur}
        loading={loading}
        // Render dropdown panel in a portal to avoid being clipped/hidden behind modals
        appendTo={typeof window !== "undefined" ? document.body : undefined}
      />
      {error && <small className="p-error block mt-1">{error}</small>}
    </div>
  );
}
